import { FiUpload } from 'react-icons/fi';

export const DragAndDrop = ({ paymentData }) => {
  // const [file, setFile] = useState(null);
  //const [input, setInput] = useState({ image: "" });
  const {
    // transationId,
    // paymentId,
    // input,
    // setInput,
    // isSubmittingPayment,
    // file,
    // setFile,
    handleFileChange,
    selectedFiles,
  } = paymentData;

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   const droppedFile = e.dataTransfer?.files[0];
  //   setFile(droppedFile);
  // };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // useEffect(() => {
  //   if (isSubmittingPayment) {
  //     console.log(isSubmittingPayment);
  //     const getPayment = async () => {
  //       try {
  //         const response = await axios.post(
  //           "/payments/proof",
  //           {
  //             payment_id: paymentId,
  //             cx_transaction_id: transationId,
  //             image: file !== null ? file : input.image,
  //           },

  //           {
  //             headers: {
  //               Authorization: `Bearer ${userToken}`,
  //               "Content-Type": "multipart/form-data",
  //             },
  //           }
  //         );
  //         toast.success("Payment proof Submitted successfully !", {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //         handleHideBankDetails();
  //         handleCancelSubmitPayment();
  //         console.log(response.data);
  //       } catch (error) {
  //         console.log(error, "error in lv account");
  //         handleCancelSubmitPayment();
  //       }
  //     };
  //     getPayment();
  //   }
  // }, [userToken, isSubmittingPayment]);

  // const handleFile = (e) => {
  //   // const { name, files } = e.target;
  //   // setInput((prev) => ({ ...prev, [name]: files[0] }));

  //   setInput((e) => e.target?.files[0]);
  // };

  return (
    <div className='flex flex-col gap-4'>
      <div className='w-full bg-t-wh rounded-lg space-y-2 p-4 text-sm'>
        <p className=' pb-1'>
          Proof of Payment{' '}
          <span className='text-s-bk'>(supported file png, jpeg, pdf)</span>
        </p>
        <div
          onDrop={handleFileChange}
          onDragOver={handleDragOver}
          className=' flex flex-col text-b-mc p-6 text-center justify-center border-dashed border-t-bk border-hf'
        >
          <h3 className='flex flex-row gap-2 mb-4 items-center justify-center'>
            <span>
              <FiUpload />
            </span>
            Drag & Drop File Here
          </h3>

          <div className='h-fit'>
            <label
              className='px-4 py-1.5 bg-b-mc text-p-wh w-fit rounded hover:bg-b-mc/75 focus:bg-b-mc/80'
              htmlFor='file-id'
            >
              Select file
            </label>
            <input
              type='file'
              id='file-id'
              name='image[]'
              // onChange={handleFile}
              // files={input?.image}
              onChange={handleFileChange}
              className='border-hf w-full sm-flex hidden'
              multiple
            />
          </div>
        </div>
        {!!selectedFiles.length && (
          <>
            <h6 className='font-semibold'>Uploaded files: </h6>
            <div className='flex flex-row justify-between bg-p-wh shadow px-4 py-2 overflow-auto'>
              {selectedFiles.map((file, index) => (
                <figure
                  className='flex flex-row items-center gap-1'
                  key={index}
                >
                  <div className='h-12 w-12'>
                    <img
                      src={file !== null && URL.createObjectURL(file)}
                      alt={file.name}
                      className='h-full w-full object-cover'
                    />
                  </div>
                  <figcaption className='py-2 w-fit rounded'>
                    {file.name}
                  </figcaption>
                </figure>
              ))}
              {/* <span className='bg-p-wh shadow rounded-full px-1.5 text-s-bk text-xs py-3 border-2 border-b-mc'>
            100%
          </span> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
